<template>
  <DpplSwitch
    v-if="route.name === 'employer-brand-report' && isAdmin"
    left="Live Jobs"
    right="Live Templates"
    :value="documentType === 'job'"
    :width="200"
    new-version
    class="mr-4 slim-switch"
    @change="toggleIsTemplate"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useActionableInsights } from '@/stores/insights/actionableInsights';
import DpplSwitch from '@/components/datapeople/DpplSwitch.vue';
import { useFilters } from '@/stores/filters/filters';
import { useSubMenu } from '@/stores/filters/subMenu';
import { useInsights } from '@/stores/insights/insights';
import { useAppAuthData } from '@/stores/app/authData';

const route = useRoute();
const router = useRouter();

const { toggleDocumentType } = useActionableInsights();
const { loadPage } = useInsights();

const { documentType } = storeToRefs(useActionableInsights());
const { isAdmin } = storeToRefs(useAppAuthData());

const toggleIsTemplate = async () => {
  toggleDocumentType();

  await loadPage({
    routeQuery: route.query || '',
    router,
    page: route.query?.page || 1,
    sort: route.query.sort,
    firstLoad: true,
    selectedMyJobs: route.query?.owned === 'true',
    searchTerm: useFilters().searchTerm,
    selectedSubMenuOption: useSubMenu().selectedSubMenuOption,
  });
};
</script>

<style lang="less" scoped>
.slim-switch {
  height: 36px !important;
  border: 1px solid @stroke-default;

  :deep(.button-background-container) {
    padding: 4px !important;
  }

  :deep(.p2) {
    font-size: 12px !important;

    &.button-background {
      height: 28px !important;
    }
  }
}
</style>
